module.exports = __webpack_public_path__ + "img/air.e58cb244.png";